/**
 * Pursuer group (Bauherr, Architekt, Polier, Handwerker) as a simple gap model:
 * mistakes shrink the gap, clean running restores it.
 */
export interface PursuitConfig {
  readonly startGap: number;
  readonly maxGap: number;
  /** Gap below which the pursuers count as "critical" (UI / audio cue later). */
  readonly criticalGap: number;
  readonly stumblePenalty: number;
  readonly recoveryPerSecond: number;
  /** Gap restored after the player survived being caught by spending a life. */
  readonly gapAfterRescue: number;
}

export const PURSUIT_CONFIG: PursuitConfig = {
  startGap: 12,
  maxGap: 12,
  criticalGap: 5,
  stumblePenalty: 7,
  recoveryPerSecond: 0.6,
  gapAfterRescue: 8,
};
